

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvatarSize } from './enums/avatar-size';
import BaseAvatar from './_base-avatar.vue';

@Component({
  name: 'BaseAvatarCounter',
  components: {
    BaseAvatar,
  },
})
export default class BaseAvatarCounter extends Vue {
  @Prop() thumbUrl?: string;
  @Prop() name: string;
  @Prop({ default: AvatarSize.Medium }) size: AvatarSize;
  @Prop() count: number;
  @Prop() counterClickable: boolean;

  handleClick() {
    this.$emit('click');
  }
}
